import { useContextFallback } from '@prenuvo/halo-foundation';

import { FormStructureContext } from './form-structure.context';

export const useFormStructure = () => useContextFallback(FormStructureContext);
